import { watch } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import { i18n } from '@/i18n'
import { useAuthStore } from '@/stores/auth'
import { authGuard } from './guards/auth.guard'
import { applyDocumentTitle } from './guards/title.guard'
import { routes } from './routes'

/**
 * 這是全域守衛的**唯一**註冊點。
 *
 * T1 有四個元件各自呼叫 `router.beforeEach` 且從不解除
 * （HeaderComponent、LeftSidebar、LeftSidebar_Live、MobileFooter），
 * 每掛載一次就多洩漏一個守衛。
 * ARCHITECTURE.md 明文禁止元件內註冊守衛，要 route 資訊請用 `useRoute()`。
 */
export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior: (_to, _from, saved) => saved ?? { top: 0 },
})

router.beforeEach(async () => {
  // 首次載入時 session 還在回復中，先等它結束再判斷登入與否，
  // 否則已登入的使用者重新整理會被誤判為訪客而踢到登入頁
  const auth = useAuthStore()
  if (auth.isRestoring) await auth.restore()

  return true
})

router.beforeEach(authGuard)

router.afterEach(applyDocumentTitle)

/**
 * 切換語言時重新套用頁籤標題。
 *
 * 標題只在導航後更新，但切語言不會導航 ——
 * 少了這段，標題會停在切換前的語言直到下次換頁。
 */
watch(i18n.global.locale, () => {
  applyDocumentTitle(router.currentRoute.value)
})
